/** @jsx jsx */
import { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import { jsx } from '@balance-web/core';

import { routerSingleParam } from '../utils/helper';
import { SignUp } from '../components/authentication';
import { Layout } from '../components/layout';
import { IdContext } from '../context';
import { useTransformError } from '../components/useErrorResponses';
import { useNavigationWithQuery } from '../components/authentication/useNavigationWithQuery';
import { SignUpConfirmation } from '../components/authentication/signUp';
import type { SignupInput } from '../services/queryClient/useMutateSignup';
import { useMutateSignup } from '../services/queryClient/useMutateSignup';
import { isError } from '../utils/utils';

export default function SignUpPoc() {
  const router = useRouter();
  const { tenancy: TENANCY, product, clientState } = useContext(IdContext);

  const { navigateTo } = useNavigationWithQuery();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [signUpSuccess, setSignUpSuccess] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');

  const { error, transformError } = useTransformError();

  // might be needed for mate invites
  // const onNavigateToInviteConfirmed = () =>
  //   navigateTo({ path: 'inviteConfirmed' });
  const signup = useMutateSignup();

  const handleSignUp = async (data: SignupInput) => {
    setMessage('');
    setSubmitting(true);
    signup.mutate(data, {
      onSuccess: (result) => {
        setSubmitting(false);
        if (isError(result)) {
          setMessage(
            result.message === 'Username already taken'
              ? 'An account with this email already exists. Use another email or sign in instead.'
              : result.message
          );
          window.scrollTo(0, 0);
          return;
        }

        setSignUpSuccess(true);
        // navigateToVerifyMfa();
      },
      onError: (err: any) => {
        transformError(err);
        setSubmitting(false);
      },
    });

    // might be needed for reckon mate or employee  invite
    // if (
    //   routerSingleParam(router?.query?.inviteId) &&
    //   routerSingleParam(router?.query?.email)
    // ) {
    //   onNavigateToInviteConfirmed();
    // } else {
    // }
  };
  if (typeof window === 'undefined') {
    return null;
  }
  return (
    <Layout product={product} theme={TENANCY}>
      {signUpSuccess ? (
        <SignUpConfirmation
          onLoginClick={() => {
            return navigateTo({ path: 'login' });
          }}
        />
      ) : (
        <SignUp
          email={routerSingleParam(router?.query?.unm)}
          error={error}
          handleSignUp={handleSignUp}
          inviteId={
            routerSingleParam(router?.query?.inviteId) ? clientState : ''
          }
          message={message}
          submitting={submitting}
          onLoginClick={() => {
            return navigateTo({ path: 'login' });
          }}
        />
      )}
    </Layout>
  );
}
